export const API_BASE_PATH = "/api/v1";

export type ApiConfig = {
  apiUrl: string;
};

export function getApiUrl(): string {
  try {
    const env = (import.meta as unknown as {env?: Record<string, string>}).env;
    if(env?.VITE_API_URL) return String(env.VITE_API_URL).replace(/\/$/, "");
  } catch {}
  if(typeof process !== "undefined" && process.env.NEXT_PUBLIC_API_URL) {
    return process.env.NEXT_PUBLIC_API_URL.replace(/\/$/, "");
  }
  if(typeof process !== "undefined" && process.env.VITE_API_URL) {
    return process.env.VITE_API_URL.replace(/\/$/, "");
  }
  return "";
}

export function apiPath(path: string): string {
  const base = getApiUrl();
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${API_BASE_PATH}${p}`;
}
